export default "__VITE_ASSET__tEwbYPEd__"